import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

export interface ChatSummaryMonthCost {
  runs: number;
  failed_runs: number;
  users: number;
  input_tokens: number;
  output_tokens: number;
  cost_nok: number;
}

/**
 * Kostnad for AI-oppsummering i Chat-rommet én måned ('YYYY-MM'), admin
 * (VIB-3027). Aggregeres i databasen (RPC chat_summary_month_cost). Raden
 * skrives av edge function-en, ikke klienten, så ingen mutasjon invaliderer
 * denne; staleTime holder den fersk nok for en kostnadsoversikt.
 */
export function useChatSummaryMonthCost(month: string, options: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: ["chat-summary-costs", month],
    enabled: !!month && (options.enabled ?? true),
    queryFn: async (): Promise<ChatSummaryMonthCost> => {
      const { data, error } = await supabase.rpc("chat_summary_month_cost", { p_month: month });
      if (error) throw error;
      const row = ((data ?? []) as Record<string, unknown>[])[0] ?? {};
      const n = (k: string) => Number(row[k] ?? 0) || 0;
      return {
        runs: n("runs"),
        failed_runs: n("failed_runs"),
        users: n("users"),
        input_tokens: n("input_tokens"),
        output_tokens: n("output_tokens"),
        cost_nok: n("cost_nok"),
      };
    },
    staleTime: 5 * 60 * 1000,
  });
}
